import { useState } from "react";
import { Outlet } from "react-router-dom";

export default function BoundaryDevice() {
  const [itemObj, setItemObj] = useState({}); //設定當前點了table哪一筆tr物件(CRUD)
  const [companyName, setCompanyName] = useState(""); // 當前公司序號
  const [tabAction, setTabAction] = useState(""); // 當前動作
  const [currentCompanySeq, setCurrentCompanySeq] = useState(""); // 當前公司序號
  const [placeList, setPlaceList] = useState([]); // 選擇公司場所
  const [queryData, setQueryData] = useState({});

  return (
    <Outlet
      context={{
        itemObj,
        setItemObj,
        companyName,
        setCompanyName,
        tabAction,
        setTabAction,
        currentCompanySeq,
        setCurrentCompanySeq,
        placeList,
        setPlaceList,
        queryData,
        setQueryData,
      }}
    />
  );
}
